import MercadoPagoRatesTable from './MercadoPagoRatesTable';

export default MercadoPagoRatesTable;